import advertising from './advertising';
import comments from './comments';
import createReviewData from './createReviewData';
import filters from './filters';
import locations from './locations';
import metadata from './metadata';
import organizations from './organizations';
import products from './products';
import ratings from './ratings';
import reviews from './reviews';
import sitesettings from './sitesettings';
import user from './user';

export const reducers = {
  sitesettings,
  metadata,
  user,
  locations,
  filters,
  organizations,
  reviews,
  ratings,
  comments,
  products,
  advertising,
  createReviewData,
};
